module.exports = "/static/assets/2de90b55229f38c202115f7febd08f8b.png";